/* unplugin-vue-components disabled */import script from "./AssessInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./AssessInfo.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__